<template>
    <SyncForm :showUseExistingTestOpt=true @update-opt="updateOpt"></SyncForm>
    <TestrunNameForm @update-opt="updateOpt" @update-qt-testrun="updateQtTestrun"></TestrunNameForm>
    <MobileAppKindForm @select-app-kind="selectAppKind"></MobileAppKindForm>
    <MobileAppForm v-if="selectedAppKind === 'apkFile'" @update-opt="updateOpt"></MobileAppForm>
    <MobileAppFormPackage v-if="selectedAppKind === 'appPackage'" @update-opt="updateOpt"></MobileAppFormPackage>
    <TestrunMemoForm @update-opt="updateOpt"></TestrunMemoForm>
    <ReportDirForm @update-opt="updateOpt"></ReportDirForm>
    <AuthProxyForm @update-opt="updateOpt"></AuthProxyForm>
</template>

<script>
import { onMounted, reactive, ref } from 'vue'

import TestrunNameForm from '@/components/forms/TestrunNameForm.vue'
import MobileAppKindForm from '@/components/forms/MobileAppKindForm.vue'
import MobileAppForm from '@/components/forms/MobileAppForm.vue'
import MobileAppFormPackage from '@/components/forms/MobileAppFormPackage.vue'
import SyncForm from '@/components/forms/SyncForm.vue'
import TestrunMemoForm from '@/components/forms/TestrunMemoForm.vue'
import ReportDirForm from '@/components/forms/ReportDirForm.vue'
import AuthProxyForm from '@/components/forms/AuthProxyForm.vue'

export default {
    name: 'TestrunMobileCmd',
    components: {
        TestrunNameForm,
        MobileAppKindForm,
        MobileAppForm,
        MobileAppFormPackage,
        SyncForm,
        TestrunMemoForm,
        ReportDirForm,
        AuthProxyForm,
    },
    setup(_, { emit }) {
        // #############
        // フォーム更新 #
        // #############
        const optDict = reactive({
            testrunName: "",
            winApp: "",
            sync: "",
            testrunMemo: "",
            reportsDir: "",
            qt: "",
        })

        const selectedAppKind = ref("apkFile")
        const selectAppKind = (kind) => {
            selectedAppKind.value = kind
        }

        // 共通化
        const updateOpt = async (key, opt) => {
            optDict[key] = opt
            await updateOpts()
        }

        // #############
        // コマンド生成 #
        // #############
        const updateOpts = async () => {
            let createdOpt = ""
            for (const key in optDict) {
                if (optDict[key]) {
                    createdOpt += ` ${optDict[key]}`
                }
            }

            // コマンド生成&表示は親コンポーネント
            emit("update-cmd", createdOpt)
        }

        // ########
        // QT制御 #
        // ########
        const testrunNameList = ref([])
        const updateQtTestrun = (nameList) => {
            testrunNameList.value = nameList
        }

        // ###############
        // ライフサイクル #
        // ###############
        onMounted(async () => {
            await updateOpt()
            selectedAppKind.value = "apkFile"
        })

        return {
            // オプション情報
            optDict,
            // コマンド生成
            updateOpt,
            // QT制御
            updateQtTestrun,
            testrunNameList,
            selectedAppKind,
            selectAppKind,
        }
    }
}
</script>
